/* tslint:disable */
import {
  Category,
  Page
} from '../index';

declare var Object: any;
export interface CostGuideInterface {
  "title": string;
  "content": string;
  "created": Date;
  "updated": Date;
  "fixr_category_id"?: string;
  "id"?: any;
  category?: Category;
  page?: Page;
}

export class CostGuide implements CostGuideInterface {
  "title": string;
  "content": string;
  "created": Date;
  "updated": Date;
  "fixr_category_id": string;
  "id": any;
  category: Category;
  page: Page;
  constructor(data?: CostGuideInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CostGuide`.
   */
  public static getModelName() {
    return "CostGuide";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CostGuide for dynamic purposes.
  **/
  public static factory(data: CostGuideInterface): CostGuide{
    return new CostGuide(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CostGuide',
      plural: 'costguides',
      properties: {
        "title": {
          name: 'title',
          type: 'string'
        },
        "content": {
          name: 'content',
          type: 'string'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
        "updated": {
          name: 'updated',
          type: 'Date',
          default: new Date(0)
        },
        "fixr_category_id": {
          name: 'fixr_category_id',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        category: {
          name: 'category',
          type: 'Category',
          model: 'Category'
        },
        page: {
          name: 'page',
          type: 'Page',
          model: 'Page'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/CostGuide.ts